import React, { useEffect } from "react";
import { Tooltip } from "@progress/kendo-react-tooltip";
import "./ToolBar.css";
import { Button } from "@progress/kendo-react-buttons";
import {
    BiShapePolygon,
    BiRuler,
    BiEdit,
    BiEraser,
    BiInfoCircle,
    BiFile,
    BiExport,
    BiImage,
    BiFilterAlt,
    BiStreetView,
    BiPaint,
    BiBookBookmark,
    BiBookOpen,
    BiSearchAlt,
    BiPrinter,
    BiImageAdd,
    BiBullseye,
} from "react-icons/bi";
import { ReactComponent as WorkOrderIcon } from "../icons/work-order.svg";
import { ReactComponent as HelpIcon } from "../icons/help.svg";
import { ReactComponent as ShareIcon } from "../icons/share.svg";
import { useSelector, useDispatch } from "react-redux";
import { setActiveTool, setSideBarOpen, setStreetView } from "../redux/toolSelectSlice";

const SelectedAnalysisIcon = BiInfoCircle;
const SelectedQueryIcon = BiSearchAlt;
const SelectedMeasureIcon = BiRuler;
const SelectedMarkupIcon = BiPaint;
const SelectedPrintIcon = BiPrinter;
const SelectedReportIcon = BiFile;
const SelectedAddLayerIcon = BiImageAdd;

const ToolBar = () => {
    const mapConfig = useSelector((state) => state.configData.mapConfig);
    const activeTool = useSelector((state) => state.toolSelect.tool);
    const dispatch = useDispatch();
    const streetViewOn = useSelector((state) => state.toolSelect.streetView);
    const thirdPartyMaps = useSelector((state) => state.configData.thirdPartyMaps);

    const thirdPartyMapsEnabled =
        thirdPartyMaps?.GoogleStreetView?.Enabled || thirdPartyMaps?.Eagleview?.Enabled
            ? true
            : false;

    const handleIdentifyTool = () => {
        if (activeTool === "identify") {
            dispatch(setActiveTool("pan"));
        } else {
            dispatch(setActiveTool("identify"));
        }
    };

    const handleQueryTool = () => {
        if (activeTool === "query") {
            dispatch(setActiveTool(undefined));
        } else {
            dispatch(setActiveTool("query"));
        }
    };

    const handleMeasureTool = () => {
        if (activeTool === "measure") {
            dispatch(setActiveTool("pan"));
        } else {
            dispatch(setActiveTool("measure"));
        }
    };

    const handleMarkupTool = () => {
        if (activeTool === "markup") {
            dispatch(setActiveTool(undefined));
        } else {
            dispatch(setActiveTool("markup"));
        }
    };

    const handleStreetView = () => {
        if (streetViewOn) {
            dispatch(setStreetView(false));
        } else {
            dispatch(setStreetView(true));
        }
    };
    const handleReportView = () => {
        if (activeTool === "reports") {
            dispatch(setActiveTool(undefined));
        } else {
            dispatch(setActiveTool("reports"));
        }
    };

    const handleBookmarks = () => {
        if (activeTool === "bookmarks") {
            dispatch(setActiveTool(undefined));
        } else {
            dispatch(setActiveTool("bookmarks"));
        }
    };

    const handlePrintTool = () => {
        if (activeTool === "print") {
            dispatch(setActiveTool(undefined));
        } else {
            dispatch(setActiveTool("print"));
        }
    };

    const handleEditTool = () => {
        if (activeTool === "edit") {
            dispatch(setActiveTool(undefined));
        } else {
            dispatch(setActiveTool("edit"));
        }
    };

    const handleAddLayer = () => {
        if (activeTool === "addLayer") {
            dispatch(setActiveTool(undefined));
        } else {
            dispatch(setActiveTool("addLayer"));
        }
    };

    const handlePlotCoordinatesTool = () => {
        if (activeTool === "plotCoordinates") {
            dispatch(setActiveTool(undefined));
        } else {
            dispatch(setActiveTool("plotCoordinates"));
        }
    };

    useEffect(() => {
        dispatch(setSideBarOpen(true));
    }, [activeTool]);

    return (
        <div className="k-drawer-container k-drawer-push k-drawer-mini" dir="ltr">
            <div
                className="k-widget k-drawer k-drawer-start"
                style={{ opacity: 1, flexBasis: 50, transition: "all 200ms ease 0s" }}>
                <div className="k-drawer-wrapper">
                    <Tooltip position="right" parentTitle={true} style={{ zIndex: 200 }}>
                        <ul
                            className="k-drawer-items"
                            role="listbox"
                            aria-label="drawer-list"
                            aria-expanded="false">
                            <Button title="Identify" shape="square" fillMode="link">
                                <li
                                    className={`k-drawer-item ${
                                        activeTool === "identify" ? "selected" : ""
                                    }`}
                                    role="option"
                                    aria-selected={""}
                                    onClick={handleIdentifyTool}>
                                    {<SelectedAnalysisIcon />}
                                </li>
                            </Button>
                            <Button
                                title="Query"
                                shape="square"
                                fillMode="link"
                                // disabled="true"
                            >
                                <li
                                    className={`k-drawer-item ${
                                        activeTool === "query" ? "selected" : ""
                                    }`}
                                    role="option"
                                    aria-selected={""}
                                    onClick={handleQueryTool}>
                                    {<SelectedQueryIcon />}
                                </li>
                            </Button>
                            <Button title="Measure" shape="square" fillMode="link">
                                <li
                                    className={`k-drawer-item ${
                                        activeTool === "measure" ? "selected" : ""
                                    }`}
                                    role="option"
                                    aria-selected={""}
                                    onClick={handleMeasureTool}>
                                    {<SelectedMeasureIcon />}
                                </li>
                            </Button>
                            <Button title="Markup" shape="square" fillMode="link">
                                <li
                                    className={`k-drawer-item ${
                                        activeTool === "markup" ? "selected" : ""
                                    }`}
                                    role="option"
                                    aria-selected={""}
                                    onClick={handleMarkupTool}>
                                    {<SelectedMarkupIcon />}
                                </li>
                            </Button>
                            <Button title="Print" shape="square" fillMode="link">
                                <li
                                    className={`k-drawer-item ${
                                        activeTool === "print" ? "selected" : ""
                                    }`}
                                    role="option"
                                    aria-selected={""}
                                    onClick={handlePrintTool}>
                                    {<SelectedPrintIcon />}
                                </li>
                            </Button>
                            {mapConfig.AddLayers.length > 0 && (
                                <Button title="Edit" shape="square" fillMode="link">
                                    <li
                                        className={`k-drawer-item ${
                                            activeTool === "edit" ? "selected" : ""
                                        }`}
                                        role="option"
                                        aria-selected={""}
                                        onClick={handleEditTool}>
                                        {<BiEdit />}
                                    </li>
                                </Button>
                            )}
                            {thirdPartyMapsEnabled && (
                                <Button
                                    title="Street View"
                                    shape="square"
                                    fillMode="link">
                                    <li
                                        className={`k-drawer-item ${
                                            streetViewOn ? "selected" : ""
                                        }`}
                                        role="option"
                                        aria-selected={""}
                                        onClick={handleStreetView}>
                                        {<BiStreetView />}
                                    </li>
                                </Button>
                            )}
                            <Button title="Report" shape="square" fillMode="link">
                                <li
                                    className={`k-drawer-item ${
                                        activeTool === "reports" ? "selected" : ""
                                    }`}
                                    role="option"
                                    aria-selected={""}
                                    onClick={handleReportView}>
                                    {<SelectedReportIcon />}
                                </li>
                            </Button>
                            <Button title="Bookmarks" shape="square" fillMode="link">
                                <li
                                    className={`k-drawer-item ${
                                        activeTool === "bookmarks" ? "selected" : ""
                                    }`}
                                    role="option"
                                    aria-selected={""}
                                    onClick={handleBookmarks}>
                                    {<BiBookOpen />}
                                </li>
                            </Button>
                            <Button title="Upload Layer" shape="square" fillMode="link">
                                <li
                                    className={`k-drawer-item ${
                                        activeTool === "addLayer" ? "selected" : ""
                                    }`}
                                    role="option"
                                    aria-selected={""}
                                    onClick={handleAddLayer}>
                                    {<SelectedAddLayerIcon />}
                                </li>
                            </Button>
                            <Button
                                title="Plot Coordinates"
                                shape="square"
                                fillMode="link">
                                <li
                                    className={`k-drawer-item ${
                                        activeTool === "plotCoordinates" ? "selected" : ""
                                    }`}
                                    role="option"
                                    aria-selected={""}
                                    onClick={handlePlotCoordinatesTool}>
                                    {<BiBullseye />}
                                </li>
                            </Button>

                            {/*<Button title="Help" shape="square" fillMode="link">
                <li
                  className={"k-drawer-item"}
                  role="option"
                  aria-selected={""}
                >
                  {<HelpIcon />}
                </li>
              </Button>*/}
                            {/*<Button title="Share" shape="square" fillMode="link">
                <li
                  className={"k-drawer-item"}
                  role="option"
                  aria-selected={""}
                >
                  {<ShareIcon />}
                </li>
              </Button>*/}
                        </ul>
                    </Tooltip>
                </div>
            </div>
        </div>
    );
};

export default ToolBar;
